import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons/faAngleLeft";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons/faAngleRight";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons/faAngleDown";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons/faAngleUp";
import { faBarcode } from "@fortawesome/free-solid-svg-icons/faBarcode";
import { faBars } from "@fortawesome/free-solid-svg-icons/faBars";
import { faCar } from "@fortawesome/free-solid-svg-icons/faCar";
import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons/faCheckCircle";
import { faCheckCircle as farCheckCircle} from "@fortawesome/free-regular-svg-icons/faCheckCircle";
import { faCircle } from "@fortawesome/free-solid-svg-icons/faCircle";
import { faCircle as farCircle} from "@fortawesome/free-regular-svg-icons/faCircle";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons/faCircleNotch";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons/faChevronUp";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons/faChevronDown";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons/faChevronLeft";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons/faChevronRight";
import { faComments } from "@fortawesome/free-solid-svg-icons/faComments";
import { faCubes } from "@fortawesome/free-solid-svg-icons/faCubes";
import { faDotCircle } from '@fortawesome/free-regular-svg-icons/faDotCircle';
import { faDownload } from "@fortawesome/free-solid-svg-icons/faDownload";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons/faEnvelope";
import { faFilter } from "@fortawesome/free-solid-svg-icons/faFilter";
import { faFolderOpen } from "@fortawesome/free-solid-svg-icons/faFolderOpen";
import { faGratipay } from "@fortawesome/free-brands-svg-icons/faGratipay";
import { faImage } from "@fortawesome/free-solid-svg-icons/faImage";
import { faLock } from "@fortawesome/free-solid-svg-icons/faLock";
import { faMapMarkerAlt as faMapMarker } from "@fortawesome/free-solid-svg-icons/faMapMarkerAlt";
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons/faPencilAlt';
import { faPhoneAlt } from "@fortawesome/free-solid-svg-icons/faPhoneAlt";
import { faPlus } from "@fortawesome/free-solid-svg-icons/faPlus";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import { faShoppingBasket } from "@fortawesome/free-solid-svg-icons/faShoppingBasket";
import { faSortAmountDownAlt } from '@fortawesome/free-solid-svg-icons/faSortAmountDownAlt';
import { faSpinner } from "@fortawesome/free-solid-svg-icons/faSpinner";
import { faStar } from "@fortawesome/free-solid-svg-icons/faStar";
import { faStarHalfAlt as faStarHalf } from "@fortawesome/free-solid-svg-icons/faStarHalfAlt";
import { faStar as farStar } from "@fortawesome/free-regular-svg-icons/faStar";
import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import { faUser } from "@fortawesome/free-solid-svg-icons/faUser";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons/faInfoCircle";
import { faHeart } from "@fortawesome/free-solid-svg-icons/faHeart";
import { faHeart as faHeartAlt } from "@fortawesome/free-regular-svg-icons/faHeart";
import { faExpandArrowsAlt } from "@fortawesome/free-solid-svg-icons/faExpandArrowsAlt";
import { faQrcode } from "@fortawesome/free-solid-svg-icons/faQrcode";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons/faSignOutAlt";
import { faSignInAlt } from "@fortawesome/free-solid-svg-icons/faSignInAlt";
import { faBox } from "@fortawesome/free-solid-svg-icons/faBox";
import { faCog } from "@fortawesome/free-solid-svg-icons/faCog";
import { faHistory } from "@fortawesome/free-solid-svg-icons/faHistory";
import { faQuestion } from "@fortawesome/free-solid-svg-icons/faQuestion";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons/faQuestionCircle";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons/faExclamationTriangle";

library.add(
    faAngleDown,
    faAngleUp,
    faAngleLeft,
    faAngleRight,
    faBarcode,
    faBars,
    faCar,
    faCheck,
    faCheckCircle,
    farCheckCircle,
    faCircle,
    farCircle,
    faCircleNotch,
    faChevronUp,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faComments,
    faCubes,
    faDotCircle,
    faDownload,
    faEnvelope,
    faFilter,
    faFolderOpen,
    faGratipay,
    faImage,
    faInfoCircle,
    faLock,
    faMapMarker,
    faPencilAlt,
    faPhoneAlt,
    faPlus,
    faSearch,
    faShoppingBasket,
    faSortAmountDownAlt,
    faSpinner,
    faStar,
    faStarHalf,
    farStar,
    faTimes,
    faUser,
    faHeart,
    faHeartAlt,
    faExpandArrowsAlt,
    faQrcode,
    faSignOutAlt,
    faSignInAlt,
    faBox,
    faCog,
    faHistory,
    faQuestion,
    faQuestionCircle,
    faExclamationTriangle
);

dom.watch();
